import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const registerUserPagoMovilDataService = async data => {
  const url = `${ConfEnv.BASE_URL}/user/profile`;

  return privateRequest.put(url, data);
};
